import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PortalFlightItineraryGroupNode } from '@app/services/api/api.types';

@Component({
  selector: 'logos-container',
  templateUrl: './logos-container.component.html',
  styleUrls: ['./logos-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogosContainerComponent {
  @Input() flightItineraries: PortalFlightItineraryGroupNode[];
}
